@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.name-title {
  font-size: 14px;
}

.edit-batch-name-button {
  font-size: 14px;
  border: none;
  box-shadow: none;
  margin-left: 5px;
  background-color: @batches--components-edit--background-color;

  &:hover {
    background: @batches--components-edit--hover--background-color;
    box-shadow: none;
  }
}

.name {
  display: flex;
  align-items: center;
  margin-right: 10px;
  flex: 1;
  height: 100%;
}

.unassigned-user {
  color: @batches--components-unassigned-user--text-color;
}

.user {
  min-width: 200px;
}

.assigned {
  height: 100%;
  display: flex;
  justify-content: flex-start;
}

.batch-note-column {
  display: flex;
  flex-direction: row;
}

.batch-already-exists {
  background-color: @batches--components--error--background-color;
  font-size: 12px;
  margin-top: 1px;
  border-radius: 2px;
  padding-bottom: 2px;
}

.single-input {
  margin-left: 5px;
}

.single-input-with-error {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  height: 30px;
  overflow-y: visible;
  margin-left: 5px;
  z-index: 2;

  > input {
    border: 1px solid @batches--components--error--border-color;
  }
}

.error-icon {
  height: 12px;
  fill: @batches--components--error--fill-color;
}
